<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: burlywood">{{ownerWebTitle}}-信息配置</span>
      <el-button type="text" style="margin-left: 5%;" @click="goToWebPriceSetting">&lt分站定价配置&gt</el-button>
    </div>
    <el-form ref="businessBaseSetting" :model="businessBaseSetting" label-width="260px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="域名" prop="webTitle">
            <el-input v-model="businessBaseSetting.salemanWebDomain" placeholder="网站域名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <span style="color: #acacac; font-size: 0.5rem;">无需http://开头，如www.baidu.com</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="名称" prop="webTitle">
            <el-input v-model="businessBaseSetting.webTitle" placeholder="分站名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="分站登录背景图" prop="usertype">
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleAvatarBackSuccess"
                :on-remove="handleAvatarRemove">
              <img v-if="businessBaseSetting.salemanWebBackImageUrl" :src="businessBaseSetting.salemanWebBackImageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="分站LOGO" prop="usertype">
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleAvatarLogoSuccess"
                :on-remove="handleAvatarRemove">
              <img v-if="businessBaseSetting.salemanWebLogo" :src="businessBaseSetting.salemanWebLogo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="主题风格" prop="themeStyle">
            <el-select ref="colorSelect" v-model="businessBaseSetting.themeStyle" clearable placeholder="" @change="colorChange">
              <el-option
                  v-for="item in backgrounds"
                  :key="item"
                  label=""
                  :value="item"
                  v-html="'<div style=background-color:'+ item +';width:' +'100%'+';height:'+'90%'+'></div>'">
                >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <el-col :span="24" style="text-align: center;">
        <el-button type="primary" @click="saveWebConfigInfo">保存</el-button>
      </el-col>
    </el-row>
  </el-card>
</div>
</template>

<script>
import {getJwtToken} from "../../lib/utils";
import {addSalemanWebConfigSetting, querySalemanWebConfigSetting} from "../../api/b2cbusiness/b2c_customoneysetting";

export default {
name: "SalemanWebSetting",
  data(){
  return {
    myheader: {
      JWTHeaderName: ""
    },
    ownerWebTitle:"分站",
    businessBaseSetting:{

    },
    backgrounds:[
      "#0066FF", "#00CCFF", "#FF3300", "#FF9933", "#45a8e9"
    ],
  }
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();
    querySalemanWebConfigSetting({salemanId:this.$route.query.salemanId}).then(res=>{
      if (res.success){
        this.ownerWebTitle = res.data.webTitle != null?res.data.webTitle:this.ownerWebTitle;
      }
    });
    this.getData();
  },
  methods:{
    handleAvatarLogoSuccess(res, file) {
      console.log(res, file);
      this.businessBaseSetting.salemanWebLogo = res.data;
      console.log(this.businessBaseSetting.salemanWebLogo)
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarBackSuccess(res, file){
      console.log(res, file);
      this.businessBaseSetting.salemanWebBackImageUrl = res.data;
      console.log(this.businessBaseSetting.salemanWebBackImageUrl)
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarRemove(file, fileList){

    },
    goToWebPriceSetting() {
      this.$router.push({path:'/home/webconfig', query:{salemanId:this.$route.query.salemanId}})
    },
    //设置颜色选择框中颜色
    setSelectColor(dom, color){
      //通过操作dom节点改变样式
      this.$nextTick(() => {
        if (dom) {
          dom = dom.$el.children[0];
          let inputDom = dom.querySelectorAll(".el-input__inner");
          let icon = dom.querySelectorAll(".el-input__icon");
          inputDom[0].style["background-color"] = color;
          inputDom[0].style["color"] = color;
          icon[0].style["color"] = "black";
        }
      })
    },
    colorChange(val){
      this.setSelectColor(this.$refs.colorSelect, val)
    },
    getData(){
      querySalemanWebConfigSetting({salemanId: this.$route.query.salemanId}).then(res=>{
        if (res.success && res.data != null){
          this.businessBaseSetting = res.data;
          this.colorChange(this.businessBaseSetting.themeStyle);
          querySalemanWebConfigSetting({salemanId:this.$route.query.salemanId}).then(res=>{
            if (res.success){
              this.ownerWebTitle = res.data.webTitle != null?res.data.webTitle:this.ownerWebTitle;
            }
          });
        }
      });
    },
    saveWebConfigInfo(){
      this.businessBaseSetting.salemanId = this.$route.query.salemanId;
      addSalemanWebConfigSetting(this.businessBaseSetting).then(res=>{
        if (res.success){
          this.getData();
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.demo-input-suffix {
  margin-bottom: 15px;
}


.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 180px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}

.avatar {
  width: 180px;
  height: 180px;
  display: block;
}
</style>
